import { render } from "./BotaoComponent.vue?vue&type=template&id=40805347&ts=true"
import script from "./BotaoComponent.vue?vue&type=script&lang=ts"
export * from "./BotaoComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__